/** @format */

import React, { useState, useEffect } from 'react'
import useGlobalData from 'src/hooks/useGlobalData'
import { RegionStateType } from 'src/store/globalDataSlice'

// type useGlobalData<TYPE, T> = (dataType: TYPE) => T

interface NavRegionProps {
  className?: string
  defaultRegion?: string
  isUpdate?: boolean
  filterResult?: (value: any[]) => any[]
  onChange?: (value: string) => void
}
const useNavRegion = (config?: NavRegionProps) => {
  const { isUpdate, defaultRegion, filterResult, onChange } = config || {}
  const [region, setRegion] = useState(defaultRegion || localStorage.getItem('systemId') || '')
  // regionList（渲染）
  const [regionList, setRegionList] = useState<RegionStateType['list']>([])
  // 如果没有传api就请求公共的regionList
  const gloabalRegionList = useGlobalData('monitorRegionList') as RegionStateType['list']
  // 初始化请求regionList
  useEffect(() => {
    if (gloabalRegionList?.length) {
      setRegionList(filterResult ? filterResult(gloabalRegionList) : gloabalRegionList)
      !region && setRegion(gloabalRegionList?.[0]?.regionKey || '')
    }
  }, [gloabalRegionList])

  useEffect(() => {
    let windowRegion
    if (regionList?.length && !windowRegion) {
      windowRegion = window['__ksStorage__'].initRegion(
        regionList.map(item => {
          return {
            ...item,
            regionCode: item.regionKey
          }
        }),
        region
      )
      window['__ksStorage__'].on('region', data => {
        if (isUpdate || isUpdate === undefined) {
          localStorage.setItem('systemId', data)
        }
        setRegion(data)
        onChange && onChange(data)
      })
    }

    return () => {
      windowRegion && windowRegion.remove()
    }
  }, [regionList])

  return region
}

export default useNavRegion
